import { useQuery } from '@tanstack/react-query';
import { getLeadPipelineStageById } from '../api/leadPipelineStages';

export function useLeadPipelineStage(id: number | null) {
  return useQuery({
    queryKey: ['settings-lead-pipeline-stages', id],
    queryFn: () => getLeadPipelineStageById(id!),
    enabled: id !== null,
  });
}
